export const INSTANCE_PVTD_READ_META_REQUEST = 'INSTANCE_PVTD_READ_META_REQUEST';
export const INSTANCE_PVTD_READ_META_SUCCESS = 'INSTANCE_PVTD_READ_META_SUCCESS';
export const INSTANCE_PVTD_READ_META_FAILURE = 'INSTANCE_PVTD_READ_META_FAILURE';
export const INSTANCE_PVTD_READ_META = [INSTANCE_PVTD_READ_META_REQUEST, INSTANCE_PVTD_READ_META_SUCCESS, INSTANCE_PVTD_READ_META_FAILURE];

export const INSTANCE_PVTD_READ_STATISTICS_REQUEST = 'INSTANCE_PVTD_READ_STATISTICS_REQUEST';
export const INSTANCE_PVTD_READ_STATISTICS_SUCCESS = 'INSTANCE_PVTD_READ_STATISTICS_SUCCESS';
export const INSTANCE_PVTD_READ_STATISTICS_FAILURE = 'INSTANCE_PVTD_READ_STATISTICS_FAILURE';
export const INSTANCE_PVTD_READ_STATISTICS = [INSTANCE_PVTD_READ_STATISTICS_REQUEST, INSTANCE_PVTD_READ_STATISTICS_SUCCESS, INSTANCE_PVTD_READ_STATISTICS_FAILURE];
